import { types, Actions } from './actions';
import { ImageComparationType } from './index';

const matches = window.innerWidth > 1024;
const initialState: ImageComparationType = {
  detailSelectImage: [],
  customerDetail: null,
  drawerState: matches,
  previosDrawerState: null,
};

const reducer = (state = initialState, actions: Actions): ImageComparationType => {
  switch (actions.type) {
    case types.SET_SELECT_IMAGES:
      return {
        ...state,
        detailSelectImage: actions.payload.listImage,
        customerDetail: actions.payload.customerDetail,
      };
    case types.SET_DRAWER_STATE:
      return {
        ...state,
        previosDrawerState: state.drawerState,
        drawerState: actions.payload,
      };
    default:
      return state;
  }
};

export default reducer;
